// extracted by css-extract-rspack-plugin
export default {"truncatedTokenWithIcon":"Shared-module__truncatedTokenWithIcon__yaplu","truncatedTokenNoIcon":"Shared-module__truncatedTokenNoIcon__bkHA6"};